import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-einvoice-tin-select-input',
  templateUrl: './einvoice-tin-select-input.component.html',
  styleUrls: ['./einvoice-tin-select-input.component.less'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EinvoiceTinSelectInputComponent),
      multi: true
    }
  ]
})
export class EinvoiceTinSelectInputComponent implements ControlValueAccessor {
  @Input() placeHolder = '';
  @Input() disabled = false;
  @Input() maxChar = 20;
  @Input() isRequired = false;
  @Input() type = 'customer';

  displayValue = '';
  showDropdown = false;
  customOptions: Array<{ label: string; value: string }> = [
    { label: 'General Public', value: 'EI00000000010' },
    { label: 'Foreign Buyer /Customer', value: 'EI00000000020' },
    { label: 'Government', value: 'EI00000000040' }
  ];

  supplierOptions: Array<{ label: string; value: string }> = [
    { label: 'General Public', value: 'EI00000000010' },
    { label: 'Foreign Supplier', value: 'EI00000000030' }
  ];

  filteredOptions: Array<{ label: string; value: string }> = [];

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  onInputChange(value: string) {
    this.displayValue = value;
    this.filterOptions(value);
    this.onChange(value);
    this.onTouched();
  }

  onInputFocus() {
    this.showDropdown = true;
    this.filterOptions(this.displayValue);
  }

  onInputBlur() {
    this.showDropdown = false;
  }

  selectOption(option: { label: string; value: string }) {
    this.displayValue = option.value;
    this.showDropdown = false;
    this.onChange(option.value);
    this.onTouched();
  }

  private filterOptions(value: string) {
    if (!value) {
      this.filteredOptions =
        this.type === 'customer' ? this.customOptions : this.supplierOptions;
      return;
    }
    this.filteredOptions =
      this.type === 'customer'
        ? this.customOptions
        : this.supplierOptions.filter(
            option =>
              option.label.toLowerCase().includes(value.toLowerCase()) ||
              option.value.toLowerCase().includes(value.toLowerCase())
          );
  }

  writeValue(value: string): void {
    this.displayValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
} 